import angular from 'angular';

import PlanModule from './plan';

export default angular
    .module('common.component.plans.component', [
        PlanModule.name
    ]);



// WEBPACK FOOTER //
// ./src/common/component/plans/component/index.js